import type { BidListItem } from '@b-stock/auction-api-client'
import { SoldAs } from '@b-stock/order-api-client'

/**
 * How the listing sold, as the viewer's own bid tells it, so only the winner
 * knows. A Buy Now bid wins and ends purchasing at once, so it's known before
 * the auction closes; a winning bid is an auction sale only once it has.
 */
const soldAsFromBid = (
  closed: boolean,
  bid: Pick<BidListItem, 'buyNowBid' | 'winning'> | null | undefined
): SoldAs | null =>
  !bid?.winning
    ? null
    : bid.buyNowBid
      ? SoldAs.BuyNow
      : closed
        ? SoldAs.Auction
        : null

export default soldAsFromBid
